import React from 'react'
import { Link } from 'react-router-dom'

import SEO from '../components/SEO'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './hakkimizda.css'

const Hakkimizda = () => {
  return (
    <div className="about-page-container teleport-dashboard-layout">
      <SEO
        title="Hakkımızda & Detailing Felsefemiz | ATEŞ AUTO DETAILING"
        description="İstanbul Beşiktaş Conrad Bosphorus stüdyomuzda otomotiv estetiğini hassas el işçiliği, şeffaf PPF ve profesyonel detailing standartlarıyla buluşturuyoruz."
        canonicalPath="/hakkimizda"
      />

      <aside className="about-sidebar-wrapper teleport-dashboard-sidebar">
        <Navigation />
      </aside>

      <main id="tq-main" className="about-content-wrapper teleport-dashboard-content">
        <section className="about-hero">
          <nav aria-label="Breadcrumb" className="about-breadcrumb">
            <Link to="/">ANA SAYFA</Link>
            <span className="about-breadcrumb-separator">/</span>
            <span aria-current="page">HAKKIMIZDA</span>
          </nav>

          <h1 className="about-headline">Hakkımızda</h1>

          <p className="about-description">
            Ateş Auto Detailing, Beşiktaş Conrad Istanbul Bosphorus bünyesindeki stüdyosunda,
            araç yüzeyine teknik hassasiyet ve butik uygulama disipliniyle yaklaşan bir otomotiv koruma ve estetik stüdyosudur.
          </p>
        </section>

        <section className="about-body">
          {/* Editoryal Hikaye / Felsefe */}
          <div className="about-editorial-block">
            <div className="about-text-col">
              <h2 className="about-section-heading">Detayda Başlayan Koruma ve Zanaat</h2>
              <p className="about-p">
                Bizim için her otomobil, kendine özgü vernik sertliğine, panel hatlarına ve estetik karaktere sahip bir mühendislik bütünüdür.
                Seri yıkama veya hızlı montaj yaklaşımlarının aksine, her aracı tekil olarak ele alıyor; yüzey analizinden son finisaj
                kontrolüne kadar geçen her evreyi titizlikle planlıyoruz.
              </p>
              <p className="about-p">
                Uyguladığımız şeffaf boya koruma filmleri (PPF), dökme folyo araç kaplamaları ve nano-seramik koruma katmanları,
                yalnızca yüzeysel bir parlaklık kazandırmakla kalmaz; aracın fabrika kondisyonunu korumaya yardımcı olan güvenilir birer kalkan işlevi görür.
              </p>
            </div>
            <div className="about-media-col">
              <img
                src="https://images.pexels.com/photos/6969026/pexels-photo-6969026.jpeg?auto=compress&cs=tinysrgb&w=1500"
                alt="Ateş Auto Detailing stüdyosunda araç yüzey hazırlığı ve detaylandırma"
                loading="lazy"
                decoding="async"
                className="about-img"
              />
            </div>
          </div>

          {/* Çalışma Standartlarımız */}
          <div className="about-principles-grid">
            <div className="about-principle-card">
              <h3 className="about-principle-title">Butik &amp; Randevulu Hizmet</h3>
              <p className="about-principle-text">
                Stüdyomuzda eşzamanlı yoğunluk yerine, her araca hak ettiği vakti ayırabilmek adına randevu sistemiyle çalışıyoruz.
                Bu yaklaşım, panel kenarlarından iç mekan detaylarına kadar tavizsiz bir işçilik standardı sunmamızı sağlar.
              </p>
            </div>

            <div className="about-principle-card">
              <h3 className="about-principle-title">Kapalı &amp; Düzenli Stüdyo Ortamı</h3>
              <p className="about-principle-text">
                Conrad Istanbul Bosphorus Otoparkı içerisinde bulunan atölyemiz, film montajı ve polisaj süreçleri için
                uygun kapalı alan koşullarını sağlayacak şekilde yapılandırılmıştır.
              </p>
            </div>

            <div className="about-principle-card">
              <h3 className="about-principle-title">Şeffaf İletişim &amp; Doğru Çözüm</h3>
              <p className="about-principle-text">
                Her araca gereksiz işlemler önermek yerine, aracın mevcut boya kondisyonuna ve kullanım alışkanlıklarınıza
                en uygun koruma paketini dürüst ve teknik bir dille paylaşıyoruz.
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </div>
  )
}

export default Hakkimizda
